import { ATTENDANCE, CLASSES, StudentServicePath } from "utils/constants";
import UpdateClassesStudentPresence from "./Edit";
import permissions from "app/permissions";

export const resources = {
  name: StudentServicePath + CLASSES + "/" + ATTENDANCE,
  title: "Присъствие на студенти",
  edit: <UpdateClassesStudentPresence />,
  editPermission: permissions.canPreviewClassAttendance,
  isMenu: false,
};
